module.exports = __webpack_public_path__ + "img/LandschaftVI.32f429cd.jpg";